import React from 'react';

function DeliveryIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10.6667 9.66691V1.00024H0.666656V9.66691H10.6667ZM10.6667 9.66691H15.3333V6.33358L13.3333 4.33358H10.6667L10.6667 9.66691ZM5.33332 11.3336C5.33332 12.2541 4.58713 13.0002 3.66666 13.0002C2.74618 13.0002 1.99999 12.2541 1.99999 11.3336C1.99999 10.4131 2.74618 9.66691 3.66666 9.66691C4.58713 9.66691 5.33332 10.4131 5.33332 11.3336ZM14 11.3336C14 12.2541 13.2538 13.0002 12.3333 13.0002C11.4128 13.0002 10.6667 12.2541 10.6667 11.3336C10.6667 10.4131 11.4128 9.66691 12.3333 9.66691C13.2538 9.66691 14 10.4131 14 11.3336Z" stroke="#2C2C2C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default DeliveryIcon;
